import { useTranslation } from 'react-i18next';
import { useTimer, formatNumber, useInitTimer, useResetTimer } from './utils';
import { TimerIcon } from '..';
import * as S from './styled';

export const Timer = ({
  initialMinutes = 5,
  mt = 12,
  hideTimer = false,
}: {
  initialMinutes?: number;
  resetTimer?: boolean;
  mt?: number;
  hideTimer?: boolean;
}) => {
  const { t } = useTranslation();
  const { minutes, seconds } = useTimer();

  useResetTimer(initialMinutes);
  useInitTimer(5);

  return (
    <S.TimerContainer $mt={mt} $hideTimer={hideTimer}>
      <TimerIcon color={'#fff'} />
      <S.TimeWrapper
        dangerouslySetInnerHTML={{
          __html: t('offer_ends', {
            time: `${formatNumber(minutes)}:${formatNumber(seconds)}`,
          }),
        }}
      />
    </S.TimerContainer>
  );
};

export * from './utils';
